import React, { useEffect, useState } from 'react';
import FullCard from '../../../../../components/Card/FullCard';
import SelectCities from '../../../../../components/FormInputs/SelectCities';
import SelectState from '../../../../../components/FormInputs/SelectState';
import SelectFleets from '../../../../../components/FormInputs/SelectFleets';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import API from '../../../../../api/axios';
import toEN from '../../../../../fns/toEn';
import formatNumber from '../../../../../fns/formatNumber';
import useTitle from 'hooks/useTitle';

function CitiesCalculations(props) {
  useTitle('تعیین کرایه شهر به شهر');
  const initialValue = {
    originCity: null,
    originState: null,
    destCity: null,
    destState: null,
    fleet: null,
    waybill: 0,
  };
  const [values, setValues] = useState(initialValue);
  const handleSelectOriginCity = (city) => {
    setValues({
      ...values,
      originCity: city,
    });
  };
  const handleSelectOriginState = (state) => {
    setValues({
      ...values,
      originState: state,
    });
  };
  const handleSelectDestCity = (city) => {
    setValues({
      ...values,
      destCity: city,
    });
  };
  const handleSelectDestState = (state) => {
    setValues({
      ...values,
      destState: state,
    });
  };
  const handleSelectFleet = (fleet) => {
    setValues({
      ...values,
      fleet,
    });
  };
  const handleChangeTextField = (e) => {
    let { name, value } = e.target;
    value = toEN(value);
    setValues({
      ...values,
      [name]: value,
    });
  };
  const loadWaybillsForOrigin = async () => {
    try {
      const response = await API.get(
        `api/v1/cityfleet/price/${values.fleet.value}/${values.originCity.value}/${values.destCity.value}`
      );
      const { price } = response.data;
      setValues({
        ...values,
        waybill: !!price ? price : 0,
      });
    } catch (error) {
      console.error(error);
    }
  };
  const setWaybillForOrigin = async () => {
    const data = {
      origin: values.originCity.value,
      destination: values.destCity.value,
      fleetPrice: [
        {
          price: values.waybill,
          fleet: values.fleet.value,
        },
      ],
    };

    try {
      const response = await API.post(`/api/v1/admin/cityfleet/price`, data);
      props.showMessage(1, '', '', 'با موفقیت بروز شد.');
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    !!values.originCity &&
      !!values.destCity &&
      !!values.fleet &&
      loadWaybillsForOrigin();
    return () => {
      // setValues(initialValue)
    };
  }, [values.originCity, values.destCity, values.fleet]);
  return (
    <FullCard
      title={props.config.name}
      category="نمایش و ویرایش کرایه حمل تعریف شده برای هر شهر و ناوگان در مدل شماره ۱"
    >
      <Grid container spacing={1} direction="column" alignItems="stretch">
        <Grid item>
          <Grid container direction="row" spacing={1}>
            <Grid item xs={12} md={6}>
              <SelectState
                isMulti={false}
                onSelect={handleSelectOriginState}
                placeholder="استان مبدا"
                localState={values.originState}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SelectCities
                isMulti={false}
                onSelect={handleSelectOriginCity}
                placeholder="شهر مبدا"
                city={values.originCity}
                localState={
                  !!values.originState ? values.originState.value : null
                }
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction="row" spacing={1}>
            <Grid item xs={12} md={6}>
              <SelectState
                isMulti={false}
                onSelect={handleSelectDestState}
                placeholder="استان مقصد"
                localState={values.destState}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SelectCities
                isMulti={false}
                onSelect={handleSelectDestCity}
                placeholder="شهر مقصد"
                city={values.destCity}
                localState={!!values.destState ? values.destState.value : null}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <SelectFleets
            isMulti={false}
            onSelect={handleSelectFleet}
            placeholder="انتخاب ناوگان "
            fleet={values.fleet}
          />
        </Grid>
        <Grid item>
          {!!values.originCity && !!values.destCity && !!values.fleet && (
            <TextField
              autoFocus
              name="waybill"
              variant="outlined"
              label="کرایه"
              fullWidth
              value={!!values.waybill ? formatNumber(values.waybill + '') : 0}
              onChange={handleChangeTextField}
            />
          )}
        </Grid>
        <Grid item>
          <Button
            color="secondary"
            variant="contained"
            fullWidth
            size="large"
            disabled={
              !!values.originCity && !!values.destCity && !!values.fleet
                ? false
                : true
            }
            onClick={setWaybillForOrigin}
          >
            ثبت
          </Button>
        </Grid>
      </Grid>
    </FullCard>
  );
}

export default CitiesCalculations;
